import React from "react"
import numeral from "numeral"

class PercentageDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>{this.props.data ? numeral(this.props.data).format('0%') : this.props.data}</div>
    );
  }

};

export default PercentageDataType